import React, { useState } from "react";
import { Modal, Typography, Button, Loader, Dropdown} from "@virkesborsen/ui-component-library";
import { ContentContainer } from "./utils/utils";
import { PropsData } from "../../../context";

export const PropertySelectStep = ({ currentStepIndex, totalSteps, handleBack, handleNext, handleClose, createCo2Deal}) => {
  const propsContext = React.useContext(PropsData);
  const [selectedProp, setSelectedProp] = useState(null);
  const [propSearchError, setPropSearchError] = useState('');
  const [isLoading,setIsLoading] = useState(false)

  const handleSubmit = async () => {
    let sbo = propsContext.props.find((itm) => itm.type == "SBO" && itm.designation == selectedProp.designation);
    //Create inital co2 deal
    setIsLoading(true);
    await createCo2Deal(selectedProp.designation);
    handleNext({
      data: {
        selectedProp:selectedProp,
        sbo:sbo
      },
    });
    setIsLoading(false);
  };

  const getDropdownOptions = () => {
    const properties = propsContext.props
    return properties.map((prop)=>({
      label:prop.designation,
      value:prop.ref
    }))

    
  }

  const handlePropSelect = async(val) => {
    let selected = propsContext.props.find((prop)=>prop.ref == val)
    if (selected.type == "SBO"){
      // Look for a property matching the forestand file check if it has dfr. If it does then set that forestand file to the property dfr or else just retain forestand dfr
      const property = propsContext.props.find((prop)=>prop.type == "PROP" && prop.designation == selected.designation)
      selected["dfr"] = property?.dfr ?? selected.dfr
    }
    setSelectedProp(selected); 
   
  }

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          width: "100%",
          flexDirection: "column",
          gap: "8px",
        }}
      >
        <Typography variant="bodyMediumBaseRegular">
          Hämtar din fastighetsdata...
        </Typography>
        <Loader />
      </div>
    );
  }

  return (
    <>
      <Modal.Content>
        <ContentContainer>
          <Typography variant="subheaderSmallMedium">Har du potential för kolkrediter i din skog?</Typography>
          <Typography variant="bodySmallRegular">Din skog kan spela en viktig roll i kampen mot klimatförändringarna. Genom att låta träden lagra koldioxid skapar du inte bara en hållbar framtid, utan kan även få nya intäktstmöjligheter.</Typography>
          <Dropdown
            name="forestand"
            label="Välj den fastighet du vill ansöka för"
            value={selectedProp?.ref}
            onChange={handlePropSelect}
            options={getDropdownOptions()}
            placeholder="Välj din fastighetsbeteckning"
            // idleText="Välj en fastighet"
            errorText={propSearchError}
            successText="Fastighet vald"
            required="true"
            validation={(val)=>true}
          />

        </ContentContainer>
      </Modal.Content>
      <Modal.Footer>
        <Button
          fullWidth
          variant="primary"
          onClick={handleSubmit}
          disabled={selectedProp ? false : true}
          label={"Nästa steg"}
          suffixIcon={"arrowRightSimple"}
        />
      </Modal.Footer>
    </>
  );
};

